import { HotTable } from '@handsontable/react';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useInput, required } from 'react-admin';
import { useRecordContext } from 'react-admin';


const GridShow = props => {





    const {
        className,
        source,
        columns = [],
        colHeaders,
        nestedHeaders,
        colWidths = [],
        ...rest
    } = props;

let  blankRow=[];
    const record = useRecordContext();

    const valueDB =record[source];
    let json = Object.assign(blankRow, valueDB);
    return (
        <div fullWidth style={{ direction: 'ltr' }}>
            <HotTable
            
                ref={(r) => { window.hot = r }}
                data={valueDB}
                readOnly= {true}
                columns={columns}
              //  colHeaders={colHeaders}
                nestedHeaders={nestedHeaders}
                minSpareRows="1"
                width='100%'
                direction='ltr'
                invalidCellClassName='htInvalid'
                overflow='hidden'
                autoWrapRow={true}
                rowHeaders={true}
                licenseKey="34af8-b0470-3cdb0-14611-d084b"
                height="300"
            />
        </div>
    );
};

GridShow.propTypes = {
    field: PropTypes.object,
   // meta: PropTypes.object,
    className: PropTypes.string,
    columns: PropTypes.array,
    colHeaders: PropTypes.array,
    nestedHeaders: PropTypes.array,
    colWidths: PropTypes.array,
};

export default GridShow;
